import { render, staticRenderFns } from "./SaveLayoutModal.vue?vue&type=template&id=4d218663&scoped=true"
import script from "./SaveLayoutModal.vue?vue&type=script&lang=js"
export * from "./SaveLayoutModal.vue?vue&type=script&lang=js"
import style0 from "./SaveLayoutModal.vue?vue&type=style&index=0&id=4d218663&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d218663",
  null
  
)

export default component.exports